// Steps/Step5Review.tsx
import { Stack, SimpleGrid, Text, Divider, Group, Avatar, Badge } from '@mantine/core';
import { fullName, getInitials } from '../types';
import type { WizardState } from '../types';
import { HtmlEditor } from '@/components';

export default function Step5Review(props: WizardState) {
  const {
    caseName, description, staged,
    allNeeds, needID, allLocations, locationID,
    allZones, zoneID, allAreas, areaID, allLeaders, leaderUserId,
  } = props;
  

  const leader: any = allLeaders.find((l) => l.userId === leaderUserId);
  const leaderLabel = leader
    ? [leader.firstName, leader.surname].filter(Boolean).join(' ').trim()
      || leader.fullName?.trim() || leader.displayName?.trim() || leader.userId
    : '—';

  return (
    <Stack gap="md">
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="sm">
        <Text size="sm"><strong>Case Name:</strong> {caseName || '—'}</Text>
        <Text size="sm">
          <strong>Need:</strong> {allNeeds.find((n) => n.needID === needID)?.name ?? '—'}
        </Text>
        <Text size="sm">
          <strong>Location:</strong> {allLocations.find((l) => l.locationID === locationID)?.name ?? '—'}
        </Text>
        <Text size="sm">
          <strong>Zone:</strong> {allZones.find((z) => z.zoneID === zoneID)?.name ?? '—'}
        </Text>
        <Text size="sm">
          <strong>Area:</strong> {allAreas.find((a) => a.areaID === areaID)?.name ?? '—'}
        </Text>
        <Text size="sm"><strong>Leader:</strong> {leaderLabel}</Text>
      </SimpleGrid>

      <Divider label={`Counselees (${staged.length})`} labelPosition="center" />
      <Stack gap={6}>
        {staged.map((s) => (
          <Group key={s.member.memberID} gap="sm">
            <Avatar src={s.member.avatar ?? undefined} size="sm" radius="xl">
              {getInitials(s.member)}
            </Avatar>
            <Text size="sm">{fullName(s.member)}</Text>
            {s.isMain && <Badge size="xs" variant="light">Main</Badge>}
          </Group>
        ))}
      </Stack>

      {description && (
        <>
          <Divider label="Description" labelPosition="center" />
           <Stack gap={6}>
            <Text size="Xl"  c="dimmed"><strong>Description.</strong></Text>
          <HtmlEditor
            value={description}
            readOnly
            showToolbar={false}
          />
          </Stack>
        </>
      )}
    </Stack>
  );
}